module.exports = __webpack_public_path__ + "img/add-layer-icon.c9c44b3b.svg";